// 企文专区
export default [
  {
    name: 'promotionCardList',
    path: '/corporateCulture/promotionCard/list',
    component: () => import('@/views/corporateCulture/promotionCard/list.vue'),
    meta: {
      title: '晋升贺卡管理'
    }
  },
  {
    name: 'circleDataList',
    path: '/corporateCulture/circleData/list',
    component: () => import('@/views/corporateCulture/circleData/list.vue'),
    meta: {
      title: '圈子数据管理'
    }
  },
  {
    name: 'honorList',
    path: '/corporateCulture/honorList/list',
    component: () => import('@/views/corporateCulture/honorList/list.vue'),
    meta: {
      title: '荣誉名单'
    }
  }
]